import dayjs from 'dayjs';

import s from './Review/Review.module.scss';

const TEXT_FORMATTERS_MAP: Record<string, string> = {
  '/n': '\n',
  '\\n': '\n',
  '/t': '\t',
  '\\t': '\t',
  '/r': '\r',
  '\\r': '\r',
};

export const fixTextFormatters = (text: string): string => {
  let formattedText = '';
  let skipNextTurn = false;

  for (let i = 0; i < text.length - 1; i++) {
    if (skipNextTurn) {
      skipNextTurn = false;
      continue;
    }

    const textFormatter = TEXT_FORMATTERS_MAP[text[i] + text[i + 1]];

    if (textFormatter) {
      formattedText += textFormatter;
      skipNextTurn = true;
      continue;
    }

    formattedText += text[i];
  }

  if (!skipNextTurn) {
    formattedText += text[text.length - 1];
  }

  return formattedText;
};

export const formatDate = (date: string): string => {
  const now = dayjs();
  const dateDayjs = dayjs(date);

  let formattedDate = '';
  if (dateDayjs.year() === now.year()) {
    formattedDate = dateDayjs.format('D MMM');
  } else {
    formattedDate = dateDayjs.format('D MMM YY[г.]');
  }

  const time = dateDayjs.format('HH:mm');
  return `${formattedDate} <span class="${s.underline}">${time}</span>`;
};
